/**
 * License Intelligence STAR Simulation & Export Mock Data
 *
 * Mock data for simulation and export API endpoints.
 * In production, these come from:
 * - POST /api/license-intelligence/trigger-simulation
 * - GET /api/sodms/rulesets
 * - POST /api/license-intelligence/v1/sap/reports/exports/async
 * - GET /api/license-intelligence/v1/sap/reports/exports/status
 * - GET /api/license-intelligence/v1/sap/reports/exports/{id}/download
 */

export const LICENSE_INTELLIGENCE_RULESETS_DATA = {
  data: [
    { id: 1, rulesetName: 'SAP STAR v2.1 - Standard' },
    { id: 2, rulesetName: 'SAP STAR v2.0 - Legacy' },
    { id: 3, rulesetName: 'SAP STAR v2.2 - Enhanced' },
  ],
  status: 200,
};

export const LICENSE_INTELLIGENCE_SIMULATION_RESPONSE = {
  message: 'Simulation started successfully',
};

export const LICENSE_INTELLIGENCE_EXPORT_CREATE_RESPONSE = {
  status: 200,
  data: { exportId: 'export-mock-001' },
  message: 'Export initiated successfully',
};

export const LICENSE_INTELLIGENCE_EXPORT_STATUS_RESPONSE = {
  userId: 'admin',
  totalExports: 1,
  inProgressExports: 0,
  completedExports: 1,
  failedExports: 0,
  exports: [
    {
      exportId: 'export-mock-001',
      status: 'COMPLETED' as const,
      progressPercentage: 100,
      errorMessage: undefined,
      createdAt: '2026-05-10T22:05:00Z',
      format: 'EXCEL' as const,
    },
  ],
};

export const LICENSE_INTELLIGENCE_EXPORT_DOWNLOAD_BLOB = new Blob(
  ['mock-export-data'],
  { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
);
